Namespace 'AccountSettings.OperatorStatus'

class AccountSettings.OperatorStatus.TimeoutCounterView extends Backbone.View
  template: JST["backbone/templates/account_settings/operator_statuses/timeout_counter"]

  initialize: (options) ->
    @inputID = options.id
    @inputStep = options.step
    @inputMin = options.min
    @inputDisabled = options.disabled
    @counter = @inputMin
    super

  render: =>
    @$el.html @template(
      inputID: @inputID, inputStep: @inputStep, inputMin: @inputMin, value: @counter, inputDisabled: @inputDisabled
    )
    @$el.find(".operator-status-input").change(@onInputChange)
    @

  onInputChange: (event) =>
    $input = $(event.target)
    if $input.val() < 5
      $input.val(5)

  onTimeoutCheck: (state) =>
    @$el.find("#" + @inputID).prop('disabled', !state)
    if state
      @$el.find("#" + @inputID).removeClass('operator-status-disabled')
      @$el.find(".operator-status-label").removeClass('operator-status-disabled')
    else
      @$el.find("#" + @inputID).addClass('operator-status-disabled')
      @$el.find(".operator-status-label").addClass('operator-status-disabled')

  setCounter: (value) =>
    if value == 0
      @setCounterToDefault()
    else
      @counter = value

  setDisabled: (state) =>
    @inputDisabled = state

  setCounterToDefault: =>
    @counter = @inputMin

  hide: =>
    @$el.addClass('d-none')

  show: =>
    @$el.removeClass('d-none')
